export default __webpack_public_path__ + "static/media/Logo.5bc1ae19.svg";